/**
 * Index/landing page labels
 */

import svIndex from '../locales/sv/index.json';
import enIndex from '../locales/en/index.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getIndexLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enIndex : svIndex;
};

export const indexLabels = (lang?: Language) => getIndexLocale(lang);
